import { useInvoice } from "../../../hooks/useInvoice";
import Input from "../../form-controls/Input";
import Note from "../../ui/Note";

const VerificationBox = ({
  disabled,
  isCode = false,
  walletName,
  otp,
  setOtp
}) => {
  const { invoice } = useInvoice();
  return (
    <div className={`verification ${disabled ? "disabled" : "active"}`}>
      <h1 className="amount fs-27">Verification</h1>
      <p>Complete this transaction with {walletName}.</p>

      <Note
        title="Note"
        content={
          <ul>
            <li>OTP expires after 30 minutes.</li>
            <li>You can resend OTP if not received.</li>
          </ul>
        }
      />
      {isCode && (
        <Input
          className="ussd-input"
          label="USSD code"
          fullWidth={true}
          value={`*144*4*6*${invoice?.amount}#`}
          allowCopy={true}
          bold={true}
        />
      )}

      <Input
        label="OTP"
        placeHolder="Type OTP here"
        fullWidth
        disabled={disabled}
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
      />
    </div>
  );
};

export default VerificationBox;
